module.exports = __webpack_public_path__ + "static/bg1-89f50d5e4195c1b0d36d91714a188c49.jpg";